<template>
    <div class="box">
        <CityTable class="ctable" ref="cityTbale1" id="topCom"></CityTable>
        <div class="home_foot" :style="{display:isShowFooter?'flex':'none'}">
            <div class="line1"><a @click="statement">特别声明</a> | <a @click="feedback">意见反馈</a> |
                <Icon type="ios-call" /> <span style="color:#878F9B;">服务热线：028-66612366</span> |
                <Icon type="md-phone-portrait" color="#2d8cf0" /> <a @click="openMobile">移动云擎</a> |
                <Icon type="md-bookmarks" color="#2d8cf0" /> <a @click="openManual">操作手册</a>
            </div>
            <div class="line1" type="text" style="box-shadow:none;" size="small" ghost> <a href="http://beian.miit.gov.cn/" target="_black">蜀ICP备20000433号-1</a> | Copyright © 2020 www.holywiser.com 众智云擎 版权所有 </div>
        </div>
        <Modal v-model="modalStateMent" width="500" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>特别声明</span>
            </p>
            <div style="height:400px;overflow-y: auto;">
                <Statement ref="statementContent"></Statement>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="closeStateMent">我知道了</Button>
                <!--  <Button type="primary" size="large" @click="sumitClearDocs">确定</Button> -->
            </div>
        </Modal>
    </div>
</template>
<script>
import CityTable from './citytable.vue'
import eventBus from "../../common/event_bus.js"
import statement from "../../stateMent.vue"
import store from '../../../store'
export default {
    name: 'SearchLocalEngineIndex',
    inject: ["reload", "topSearchParameter", "sliders"],
    data() {
        return {
            introimg:'/manual/logo/',
            modalStateMent: false,
            value1: "1",
            //classId: "",
            tagData: {}, //this.getTreeData(),
            // sTreeIndustry: this.getIndustryData(0),
            // streeProvince: this.getProvince(),
            searchParams: {
                // city: "",
                // province: "",
                // country: "全国",
                // classid: "",

            },
            isShowFooter:!store.state.user.isjxt,
        }
    },
    provide() {
        return {
            parentSearchParams: this.searchParams,
        }
    },
    components: {
        'CityTable': CityTable,
        'Statement': statement,
    },
    created() {
        // console.log('on-city-select.created=======>')
        if (this.topSearchParameter.city) {
            if (this.topSearchParameter.city[0]) {
                this.searchParams.province = this.topSearchParameter.city[0]
            }
            if (this.topSearchParameter.city[1]) {
                this.searchParams.city = this.topSearchParameter.city[1]
            }
            this.searchParams.classid = this.topSearchParameter.classid
        }
        // this.routerParams.city = this.$route.query.city
        // this.routerParams.province = this.$route.query.province
        // this.routerParams.classid = this.$route.query.classid === undefined ? "" : this.$route.query.classid
        // console.log("routerParams.classid:" + this.routerParams.classid)
        if (this.isTempLogin === true) {
            //this.handle_getNewFiles(1, id)
        }
    },
    methods: {
        openManual() {
            eventBus.$emit("open_manual")
            // this.$router.push({ name: 'usermanual' })
        },
        openMobile() {
            // console.log(store.state.user.sliders.length)
            eventBus.$emit("open_mobile")
        },
        feedback() {
            eventBus.$emit("statement_on")
        },
        statement() {
            this.modalStateMent = true
        },
        closeStateMent() {
            this.modalStateMent = false
        },
        onEngineSearching() {
            this.$refs.cityTbale1.value1 = ""
            this.scrollIntoViewResult()
        },
        scrollIntoViewResult() {
            var element = document.getElementById("dividerDesc");
            element.scrollIntoView();
        },
        scrollIntoViewResult1() {
            var element = document.getElementById("topCom");
            element.scrollIntoView();
        },
        showLocalView() {
            //this.$refs.cityTbale1.value1 = "1"
            this.scrollIntoViewResult1()
        },
    },
    mounted: function() {
        eventBus.$on('city-select', (data, iscity = false) => {
            console.log("on-city-select===============>")
            this.showLocalView()
            console.log(data)
            //console.log(data.city.length)
            var params = {}
            if (data.city.length === 1) {
                params.province = data.city[0]
                params.city = []

            } else if (data.city.length === 2) {
                params.province = data.city[0]
                params.city = data.city[1]
            }
            params.country = "中央"
            params.classid = data.classid
            this.searchParams = params
            // console.log('search_local_main...')
            // console.log(this)
            console.log(this.searchParams)
            //选择城市清除查询条件
            if (iscity) {
                this.$refs.cityTbale1.$refs.topSearchBar.resetCondition()
            }
            this.$refs.cityTbale1.getRegion(this.searchParams)


        })
        console.log('localindex mounted===>')
        // //lunch guide
        eventBus.$emit("lunch-guide")

    },
    beforeDestroy() {
        eventBus.$off('city-select')
    },
    // updated: function() {
    //   this.$nextTick(function() {
    //     console.log('updated...')
    //   })
    // },
    watch: {
        sliders: function(v) {
            //console.log('search_local_main.vue==================>',v)
            if (store.state.user.isjxt) {
                this.isShowFooter = false
            } else {
                if (v.length > 1) {
                    this.isShowFooter = false
                } else {
                    this.isShowFooter = true
                }
            }

        },
        '$route'(to, from) {
            //console.log('to--->',to)
            //console.log('this.$route.query.classid', this.routerParams.classid)
            // let tempObj = {}
            // tempObj.city = this.$route.query.city
            // tempObj.province = this.$route.query.province
            // tempObj.country = "全国"
            // tempObj.classid = this.$route.query.classid
            // console.log('watch search_local_main...')
            // console.log(tempObj)
            // this.gRegion = tempObj;
            // this.$refs.cityTbale1.getRegion(tempObj)

            // if (this.$route.query.city === undefined || tempObj.city === "") {
            //   console.log("provinceNextSearch....")
            //   this.$refs.cityTbale1.isCityShow = false
            //   this.$refs.cityTbale1.provinceNextSearch()
            // } else {
            //   console.log("cityNextSearch....")
            //   this.$refs.cityTbale1.isCityShow = true //重新渲染组件时，需要再组件渲染完成时设置组件的属性
            //   this.$nextTick(function() {
            //     this.$refs.cityTbale1.cityNextSearch()
            //   })
            // }

            //this.reload()

        }
    }
}
</script>


<style lang="scss">
</style>

<style lang="less" scoped>


.common-width {
    width: 250px;
}

.box {
    display: flex;
    flex-direction: column;
}

.ctable {
    flex: 9;
    display: flex;
    flex-direction: column;
    // background: green;
}

.home_foot {
    // position: absolute;
    // bottom: 20px;
    margin-bottom: 20px;
    align-items: center;
    display: flex;
    flex: 1;
    width: 100%;
    text-align: center;
    // background: #F7F9FA;
    color: #878F9B;
    flex-direction: column;

    .line1 {

        height: 20px;
        line-height: 20px;
        text-align: center;
        display: block;
        flex: 1;
    }
}
</style>